<header class="header">
    <div class="header-left">
        <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo">
        <h6>Autoenrolamiento para autoridades.</h6>
    </div>
</header>

<form [formGroup]="formAutoE" novalidate>
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <div class="card shadow-sm" style=" width: 100%;">
            <div class="card-body">
                <label class="form-label mb-1" for="tipoOrganismoSelect">Selección de dependencia</label>
                <div class="d-flex align-items-center gap-2 contenedorSelect">

                    <ng-select id="tipoDependenciaSelect" name="tipoDependenciaSelect" style="width: 100%;"
                        [items]="(catDep$ | async)?.data!" bindLabel="nombre" [minTermLength]="3"
                        [trackByFn]="trackByFn" typeToSearchText="Para buscar escriba 3 o mas caracteres"
                        bindValue="catTipoOrganismoId" notFoundText="No se encontraron resultados" clearAllText="Limpiar" loadingText="Cargando..." [loading]="catDeploading" [typeahead]="catDepInput$"
                        formControlName="dependencia" placeholder="Seleccione la denominación de su dependencia">
                        <!-- <ng-option value="null">
                            Seleccionar
                        </ng-option>
                        @if (catDep$ | async; as c) {
                        @for (item of c.data; track $index) {
                        <ng-option [value]="item.catTipoOrganismoId">
                            {{item.nombre}}
                        </ng-option>
                        }
                        } -->
                    </ng-select>
                    <p>En caso de no localizar su dependencia en el catálogo, para realizar su alta favor de mandar
                        correo a la siguiente cuenta:
                        <a href="mailto:dggj.interconexion@oaj.gob.mx ">dggj.interconexion@oaj.gob.mx </a>
                    </p>
                </div>

                <label class="form-label mb-1" for="autoridadText">Autoridad</label>
                <div class="d-flex align-items-center gap-2 contenedorSelect">
                    <input type="text" class="form-control" maxlength="501"
                        [class.is-invalid]="formAutoE.get('autoridad')?.invalid && formAutoE.get('autoridad')?.touched"
                        formControlName="autoridad" placeholder="Ingrese la denominación de la Autoridad a dar de alta. Nombre completo y sin abreviaturas.">

                    @if (formAutoE.get('autoridad')?.errors && formAutoE.get('autoridad')?.touched) {
                    @if (formAutoE.get('autoridad')?.hasError('required')) {
                    <div class="invalid-feedback">
                        <span>La autoridad es requerida</span>
                    </div>
                    }
                    @if (formAutoE.get('autoridad')?.hasError('maxlength')) {
                    <div class="invalid-feedback">
                        <span>El número de caracteres permitidos es de 500</span>
                    </div>
                    }

                    <!-- @if (formAutoE.get('autoridad')?.hasError('wordAutoEnromientoValidacion') || formAutoE.get('autoridad')?.invalid) {
                    <div class="invalid-feedback">
                        <span>Por la naturaleza de las funciones de su institución, para realizar su alta favor de
                            mandar correo a la siguiente cuenta: dggj.interconexion@oaj.gob.mx</span>
                    </div>
                    } -->
                    }
                    @if (formAutoE.get('autoridad')?.hasError('wordAutoEnromientoValidacion')) {
                    <div class="invalid-feedback">
                        <span>Por la naturaleza de las funciones de su institución, para realizar su alta favor de
                            mandar correo a la siguiente cuenta: dggj.interconexion@oaj.gob.mx</span>
                    </div>
                    }
                </div>

                <label class="form-label mb-1" for="solicitanteText">Solicitante</label>
                <div class="d-flex align-items-center gap-2 contenedorSelect">
                    <input type="text" class="form-control" maxlength="501"
                        [class.is-invalid]="formAutoE.get('solicitante')?.invalid && formAutoE.get('solicitante')?.touched"
                        formControlName="solicitante" placeholder="Ingrese su nombre completo">
                    <p>Ingrese su nombre completo, como la persona servidora pública que está realizando la solicitud
                        para dar de alta a la Autoridad en la plataforma</p>
                    @if (formAutoE.get('solicitante')?.errors && formAutoE.get('solicitante')?.touched) {
                    @if (formAutoE.get('solicitante')?.hasError('required')) {
                    <div class="invalid-feedback">
                        <span>El solicitante es requerido</span>
                    </div>
                    }
                    @if (formAutoE.get('solicitante')?.hasError('maxlength')) {
                    <div class="invalid-feedback">
                        <span>El número de caracteres permitidos es de 500</span>
                    </div>
                    }
                    }            

                </div>
            </div>
        </div>
    </div>

    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <div class="card shadow-sm" style=" width: 100%;">
            <div class="card-body">
                <h5 class="card-title">Datos de contacto</h5>
                <label class="form-label mb-1" for="solicitanteText">Correo oficial de la institución</label>
                <div class="d-flex align-items-center gap-2 contenedorSelect">
                    <input type="text" class="form-control"
                        maxlength="101"
                        [class.is-invalid]="(formAutoE.get('correoInstitucion')?.invalid && formAutoE.get('correoInstitucion')?.touched) || formAutoE.hasError('correosIguales')"
                        formControlName="correoInstitucion" placeholder="Ingrese el correo electrónico oficial">

                    <p style="text-align: justify;">Ingrese el correo electrónico oficial de la autoridad en el cual pueda recibir comunicaciones administrativas de la plataforma, como por ejemplo, verificación de la cuenta y cambio de contraseña. Nota: el sistema aceptará diversos dominios, tanto institucionales como comerciales, sin embargo, es importante que se considere que la cuenta esté asociada a la autoridad que se dará de alta y no a la cuenta personal de un servidor público.</p>
                    @if (formAutoE.get('correoInstitucion')?.errors && formAutoE.get('correoInstitucion')?.touched) {
                    @if (formAutoE.get('correoInstitucion')?.hasError('required')) {
                    <div class="invalid-feedback">
                        <span>El correo de la institucion es requerido</span>
                    </div>
                    }
                    @if (formAutoE.get('correoInstitucion')?.hasError('email')) {
                    <div class="invalid-feedback">
                        <span>Validar correo eléctronico</span>
                    </div>
                    }
                    @if (formAutoE.get('correoInstitucion')?.hasError('maxlength')) {
                    <div class="invalid-feedback">
                        <span>El número de caracteres permitidos es de 100</span>
                    </div>
                    }
                    }
                    @if (
    formAutoE.hasError('correosIguales') &&
    (formAutoE.get('correoInstitucion')?.touched ||
     formAutoE.get('correoSolicitante')?.touched)
) {
<div class="invalid-feedback d-block">
    <span>
        El correo de la institución y el correo del solicitante no pueden ser iguales.
    </span>
</div>
}
                </div>

                <label class="form-label mb-1" for="solicitanteText">Correo oficial del solicitante</label>
                <div class="d-flex align-items-center gap-2 contenedorSelect">
                    <input type="text" class="form-control" maxlength="101"
                        [class.is-invalid]="(formAutoE.get('correoSolicitante')?.invalid && formAutoE.get('correoSolicitante')?.touched) || formAutoE.hasError('correosIguales')"
                        formControlName="correoSolicitante" placeholder="Ingrese su correo electrónico institucional">
                    <p>Ingrese su correo electrónico institucional en el cual se pueda establecer contacto en caso de
                        alguna duda con el registro de alta solicitado</p>
                    @if (formAutoE.get('correoSolicitante')?.errors && formAutoE.get('correoSolicitante')?.touched) {
                    @if (formAutoE.get('correoSolicitante')?.hasError('required')) {
                    <div class="invalid-feedback">
                        <span>El correo de solicitante es requerido</span>
                    </div>
                    }
                    @if (formAutoE.get('correoSolicitante')?.hasError('email')) {
                    <div class="invalid-feedback">
                        <span>Validar correo eléctronico</span>
                    </div>
                    }
                    @if (formAutoE.get('correoSolicitante')?.hasError('maxlength')) {
                    <div class="invalid-feedback">
                        <span>El número de caracteres permitidos es de 100</span>
                    </div>
                    }
                    }
                    
@if (
    formAutoE.hasError('correosIguales') &&
    (formAutoE.get('correoInstitucion')?.touched ||
     formAutoE.get('correoSolicitante')?.touched)
) {
<div class="invalid-feedback d-block">
    <span>
        El correo de la institución y el correo del solicitante no pueden ser iguales.
    </span>
</div>
}

                </div>

                <label class="form-label mb-1" for="solicitanteText">Teléfono institucional del solicitante</label>
                <div class="d-flex align-items-center gap-2 contenedorSelect">
                    <input type="text" class="form-control" maxlength="51"
                        [class.is-invalid]="formAutoE.get('telSolicitante')?.invalid && formAutoE.get('telSolicitante')?.touched"
                        formControlName="telSolicitante" placeholder="Ingrese su número de teléfono institucional">
                    <p>Ingrese su número de teléfono institucional en el cual se pueda establecer contacto en caso de
                        alguna duda con el registro de alta solicitado</p>
                    @if (formAutoE.get('telSolicitante')?.errors && formAutoE.get('telSolicitante')?.touched) {
                    @if (formAutoE.get('telSolicitante')?.hasError('required')) {
                    <div class="invalid-feedback">
                        <span>El telefono del solicitante es requerido</span>
                    </div>
                    }
                    @if (formAutoE.get('telSolicitante')?.hasError('maxlength')) {
                    <div class="invalid-feedback">
                        <span>El número de caracteres permitidos es de 50</span>
                    </div>
                    }
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <div class="card shadow-sm" style=" width: 100%;">
            <div class="card-body">
                <div class="row">
                    <div class="col-12 col-sm-auto">
                        <h5 class="card-title">Documentación</h5>
                        <div class="aviso-frame">
                            <p>
                                Ingrese la siguiente documentación, ya sea conformando un solo archivo o en varios: su nombramiento, identificación y oficio de autorización, como la persona servidora pública autorizada para realizar la solicitud de alta a la Autoridad en la plataforma.
                            </p>
                            <p>
                                Al ingresar el documento, verificar que el nombre del archivo no cuente con signos de
                                puntuación, admiración o caracteres especiales como apóstrofes, guiones, etc.
                            </p>
                            <p>
                                Nota: El tamaño límite de los archivos debe ser 40 MB por documento, mismos que en su
                                conjunto no deberán de exceder de 360 MB por envío.
                            </p>
                        </div>
                        <div class="row mt-3 justify-content-end">
                            <div class="col-12 col-sm-auto">
                                <button class="btn btn-file" type="button" [disabled]="formDesabilitar"
                                    (click)="openWindowFirma()">Seleccionar archivos</button>
                            </div>
                        </div>

                        @if(isLoadingFile) {
                        <div class="center">
                            <oaj-loader-itx [loading]="isLoadingFile" [sMensaje]="sMensajeLoad"
                                #loaderSpinner></oaj-loader-itx>
                        </div>
                        }@else if(lstDocumentos.length > 0) {
                        <oaj-lista-archivos-itx class="form-control listado" [archivos]="lstDocumentos"
                            [verBorrar]="true" (BorraDoc)="EliminarDocumentosPantalla($event)" [verPrevisualizar]="true"
                            [OcultaSystemName]="true">
                        </oaj-lista-archivos-itx>
                        }
                    </div>
                </div>
                <label class="form-label mb-1" for="solicitanteText">Observaciones</label>
                <div class="d-flex align-items-center gap-2 contenedorSelect">
                    <textarea maxlength="5001" class="form-control" placeholder="Observaciones" id="exampleFormControlTextarea1"
                    [class.is-invalid]="formAutoE.get('observaciones')?.invalid && formAutoE.get('observaciones')?.touched"
                        formControlName="observaciones" rows="3"></textarea>
                        
                    @if (formAutoE.get('observaciones')?.errors && formAutoE.get('observaciones')?.touched) {
                    @if (formAutoE.get('observaciones')?.hasError('maxlength')) {
                    <div class="invalid-feedback">
                        <span>El número de caracteres permitidos es de 5000</span>
                    </div>
                    }
                    }
                </div>

                <div class="d-flex align-items-center justify-content-center gap-2">
                    @if (captchaValido === false) {
                        <cjf-textual #captchaComponent (respuesta)="respuestaCaptcha($event)"></cjf-textual>
                    }
                    @else {
                        <div class="alert alert-success" role="alert">
                            <span>Captcha validado</span>
                        </div>
                    }
                </div>

                <div class="d-flex justify-content-md-end gap-2 mt-3">
                    @if(loading) {
                    <div class="center">
                        <oaj-loader-itx [loading]="loading" [sMensaje]="sMensajeLoading"
                            #loaderSpinner></oaj-loader-itx>
                    </div>
                    }
                    @else {
                    <button type="submit" [disabled]="formDesabilitar" (click)="onSubmit()"
                        class="btn btn-envio">
                        Enviar
                    </button>
                    }
                </div>
            </div>
            <oaj-alert-itx></oaj-alert-itx>
        </div>
    </div>
</form>

<!-- {{getForm() | json}}
<br>
{{lstDocumentos | json}}
<br>
{{docFirmados()}}
<br>
{{getPalabraInvalida()}} -->